<template>
  <div class="exam-info-dialog">
    <el-dialog
      v-if="dialogVisible"
      :title="DialogTitle"
      :visible.sync="dialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div v-loading="loading">
        <div class="form-item">
          <label>考试时间：</label>
          <span>{{ examInfo.date }}   {{ examInfo.startTime }}-{{ examInfo.endTime }}</span>
        </div>
        <p class="form-item">
          <label>考核方式：</label>
          <span>{{ examInfo.way }}</span>
        </p>
        <p class="form-item">
          <label>备注：</label>
          <span>{{ examInfo.remark || '-' }}</span>
        </p>
        <div class="form-item item-table">
          <label>考试安排：</label>
          <ming-table v-model="examInfo.examinationRoom" max-height="400px" :fields="examInfoColumn"></ming-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import API from '@/api'
const props = defineProps({
  visible: {
    type: Boolean,
    default: () => false
  },
  courseId: {
    type: [Number, String],
    default: () => ''
  }
})

const examInfoColumn = ref([
  {
    label: '考试地点',
    field: 'place'
  },
  {
    label: '监考老师',
    field: 'monitor'
  },
  {
    label: '备注',
    field: 'remark'
  }
])

const DialogTitle = ref('考试安排')
const loading = ref(false)

const dialogVisible = computed(() => {
  return props.visible
})

const emit = defineEmits(['handleCLose'])

function handleClose() {
  emit('update:visible', false)
}

const examInfo = ref({
  date: '',
  endTime: '',
  examinationRoom: [],
  remark: '',
  startTime: '',
  way: ''
})

function getExamInfo(id) {
  loading.value = true
  API.MBAExamInfoSet({ id })
    .then(res => {
      if (+res.code === 200) {
        examInfo.value = {
          ...res.data
        }
      }
      loading.value = false
    })
    .catch(_ => {
      loading.value = false
    })
}

onMounted(() => {
  const { courseId } = props

  getExamInfo(courseId)
})
</script>

<style lang="scss" scoped>
.exam-info-dialog {
  .form-item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    label {
      display: block;
      width: 100px;
    }
    p {
      padding: 0;
      margin: 0;
    }
    &.item-table {
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      label {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
